import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AREAS_PALETTE } from '../areasPalette';
import { FONT_SIZE } from '../agendaStyles';
import { formatSeconds } from '../utils/areasFormat';

const TIME_PLACEHOLDER = '\u0000';

type AgendaNowDividerProps = {
  nowSeconds: number;
  timeFormat: string;
};

/** The "now" line between the cards that already started and the ones still to come. */
export const AgendaNowDivider = ({ nowSeconds, timeFormat }: AgendaNowDividerProps) => {
  const { t } = useTranslation();
  const timeLabel = formatSeconds(nowSeconds, timeFormat);
  // The time sits in its own dir="ltr" span, so translate around a placeholder and split on it.
  const [labelBefore, labelAfter = ''] = t('calendar.areas_view.now_divider', { time: TIME_PLACEHOLDER }).split(
    TIME_PLACEHOLDER,
  );
  return (
    <Grid
      data-now-divider
      container
      alignItems="center"
      wrap="nowrap"
      sx={{ height: '22px', marginBlock: 0.5, position: 'relative' }}>
      <Grid
        sx={{
          position: 'absolute',
          insetInline: 0,
          top: '10px',
          height: '2px',
          backgroundColor: AREAS_PALETTE.nowMarker,
        }}
      />
      <Typography
        component="span"
        sx={{
          position: 'relative',
          fontSize: FONT_SIZE.caption,
          fontWeight: 700,
          color: 'mb.surface',
          backgroundColor: AREAS_PALETTE.nowMarker,
          borderRadius: '4px',
          paddingInline: 1.25,
          lineHeight: '22px',
          whiteSpace: 'nowrap',
        }}>
        {labelBefore}
        <span dir="ltr">{timeLabel}</span>
        {labelAfter}
      </Typography>
    </Grid>
  );
};
